import { admin } from '~/services/api';

export const getHomeDrivers = ({
  kms,
  seats,
  latitude,
  longitude,
  category,
  city,
}) =>
  admin.get(
    `/relep/search?kms=${kms}&seats=${seats}&latitude=${latitude}&longitude=${longitude}&category=${category}&city=${city}`
  );
